import { Disclosure } from '@headlessui/react';

export default function ReadMore({ text, maxChars = 200 }: { text: string; maxChars?: number }) {
    const isLong = text.length > maxChars;
    const shortText = text.slice(0, maxChars);

    return (
        <Disclosure>
            {({ open }) => (
                <div>
                    <p>{open || !isLong ? text : `${shortText}...`}</p>

                    {isLong && (
                        <Disclosure.Button className="text-brand-primary-light mt-1">
                            {open ? 'Read less' : 'Read more'}
                        </Disclosure.Button>
                    )}
                </div>
            )}
        </Disclosure>
    );
}
